import { useEffect, useState } from 'react';
import { Alert, Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    alias: string,
    changingTo: boolean,
    onCancel: () => void,
    onConfirm: (reason: string) => void
}

const AddBackCreditReasonModal = (props: IProps) => {
    const [reason, setReason] = useState('');
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (!props.show) {
            setReason('');
            setDirty(false);
        }
    }, [props.show])

    const validate = (dirty: boolean) => {
        let reasonValid = dirty ? reason.trim() != '' : true;

        return { reasonValid, isValid: reasonValid };
    }

    const handleSubmit = () => {
        setDirty(true);

        if (validate(true).isValid) {
            props.onConfirm(reason.trim());
        }
    };

    const { reasonValid, isValid } = validate(dirty)

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Change Add Back Credit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isValid && (
                    <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                        The fields in <strong>red</strong> are required...
                    </Alert>
                )}

                <blockquote>
                    <div>Alias: {props.alias}</div>
                    <div>Changing add back credit to <strong>{props.changingTo ? 'Yes' : 'No'}</strong></div>
                </blockquote>

                <FormGroup validationState={reasonValid == false ? 'error' : null}>
                    <ControlLabel>Reason For Change</ControlLabel>
                    <FormControl
                        componentClass='textarea'
                        rows={3}
                        maxLength={500}
                        value={reason}
                        onChange={(e: React.FormEvent<FormControl & HTMLTextAreaElement>) => setReason(e.currentTarget.value)}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button bsStyle='primary' onClick={handleSubmit} disabled={reason.trim() == ''}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddBackCreditReasonModal;
